<template lang="pug">
  div(class="history-wrap")
    section-title(title="データで見るSMOUT")
    history-title(:icon="userIcon", title="ユーザー数", class="history-title")
    div(class="box")
      history-time(class="history-time")
      user-counter(class="userCounter")
</template>
<script>
  import HistoryTime from 'modules/components/Event/Infographics/HistoryTime.vue';
  import HistoryTitle from 'modules/components/Event/Infographics/HistoryTitle.vue';
  import SectionTitle from 'modules/components/Event/Infographics/SectionTitle.vue';
  import UserCounter from 'modules/components/Event/Infographics/UserCounter.vue';
  import UserIcon from 'images/Event/Infographics/user.svg';

  export default {
    components: {
      HistoryTime,
      HistoryTitle,
      SectionTitle,
      UserCounter,
    },
    data() {
      return {
        userIcon: UserIcon,
      };
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .history-wrap {
    position: relative;
    padding-top: 40px;
    padding-bottom: 90px;
    @include mq('sm') {
      border-width: 128px;
    }
  }
  .history-title {
    margin-top: 20px;
    margin-bottom: 30px;
    @include mq('sm') {
      position: absolute;
      right: 5%;
      top: 10%;
      margin-top: 0;
    }
    @include mq {
      right: 10%;
      top: 13%;
    }
  }
  .box {
    display: flex;
    padding-top: 10px;
  }
  .history-time {
    flex: 0 0 120px;
    @include mq('xs') {
      flex: 0 0 100px;
    }
  }
  .userCounter {
    flex: 1 1 50%;
    @include mq('sm') {
      padding-left: 20px;
    }
  }
</style>
